import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { useEffect, lazy, Suspense } from "react";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import { CookieConsent } from "@/components/CookieConsent";

// Lazy-loaded pages for code splitting
const Agency = lazy(() => import("@/pages/Agency"));
const Services = lazy(() => import("@/pages/Services"));
const ServiceDetail = lazy(() => import("@/pages/ServiceDetail"));
const Clients = lazy(() => import("@/pages/Clients"));
const Partners = lazy(() => import("@/pages/Partners"));
const Formations = lazy(() => import("@/pages/Formations"));
const Blog = lazy(() => import("@/pages/Blog"));
const ResourcesHub = lazy(() => import("@/pages/ResourcesHub"));
const ResourcesPage = lazy(() => import("@/pages/ResourcesPage"));
const ResourceDetail = lazy(() => import("@/pages/ResourceDetail"));
const Contact = lazy(() => import("@/pages/Contact"));
const Admin = lazy(() => import("@/pages/Admin"));
const IAAutomatisation = lazy(() => import("@/pages/IAAutomatisation"));
const BrandSolutions = lazy(() => import("@/pages/BrandSolutions"));
const OffresPricing = lazy(() => import("@/pages/OffresPricing"));
const ExperienceClientCRM = lazy(() => import("@/pages/ExperienceClientCRM"));
const SeoGeo = lazy(() => import("@/pages/SeoGeo"));
const AcquisitionDigitale = lazy(() => import("@/pages/AcquisitionDigitale"));
const MentionsLegales = lazy(() => import("@/pages/MentionsLegales"));
const PolitiqueConfidentialite = lazy(() => import("@/pages/PolitiqueConfidentialite"));
const ArticleDetail = lazy(() => import("@/pages/ArticleDetail"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Toaster position="top-right" richColors />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/agence" element={<Layout><Agency /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/services/ia-automatisation" element={<Layout><IAAutomatisation /></Layout>} />
          <Route path="/services/brand-solutions" element={<Layout><BrandSolutions /></Layout>} />
          <Route path="/services/offres-pricing" element={<Layout><OffresPricing /></Layout>} />
          <Route path="/services/experience-client-crm" element={<Layout><ExperienceClientCRM /></Layout>} />
          <Route path="/services/seo-geo" element={<Layout><SeoGeo /></Layout>} />
          <Route path="/services/acquisition-digitale" element={<Layout><AcquisitionDigitale /></Layout>} />
          <Route path="/services/:slug" element={<Layout><ServiceDetail /></Layout>} />
          <Route path="/clients" element={<Layout><Clients /></Layout>} />
          <Route path="/partenaires" element={<Layout><Partners /></Layout>} />
          <Route path="/formations" element={<Layout><Formations /></Layout>} />
          <Route path="/blog" element={<Layout><Blog /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><ArticleDetail /></Layout>} />
          <Route path="/ressources" element={<Layout><ResourcesHub /></Layout>} />
          <Route path="/ressources/telechargements" element={<Layout><ResourcesPage /></Layout>} />
          <Route path="/ressources/:slug" element={<Layout><ResourceDetail /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/mentions-legales" element={<Layout><MentionsLegales /></Layout>} />
          <Route path="/politique-de-confidentialite" element={<Layout><PolitiqueConfidentialite /></Layout>} />
        </Routes>
      </Suspense>
      <CookieConsent />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
